import { ColorScheme, colorSchemes } from '../constants/colorSchemes';

const getColorSchemeFromString = (str: string): ColorScheme =>
    colorSchemes.find(colorScheme => colorScheme === str) || 'neutral';

export default getColorSchemeFromString;
